import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-excercise-progress-dialog',
  templateUrl: './excercise-progress-dialog.component.html',
  styleUrls: ['./excercise-progress-dialog.component.css']
})
export class ExcerciseProgressDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ExcerciseProgressDialogComponent>, 
    @Inject(MAT_DIALOG_DATA,) public data: any
    ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

}
